import React, {useState} from 'react'
import PropTypes from 'prop-types'
// import compose from 'recompose/compose'
import Hidden from '@mui/material/Hidden';
import theme from '../../../theme'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box';

// material ui
import IconButton from '@mui/material/IconButton'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// import TimeInput from ''material-ui-time-picker
import CloseIcon from '@mui/icons-material/Close'
import Switch from '@mui/material/Switch';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';

// application setting
import SettingsSVG from '../../../assets/settingsSVG'
import Aux from '../../../hoc/Ax/Ax'
import moment from "moment";
import Slider from "../../Slider/Slider";
import Information from "../../Information/Information";
import Mode from "../../Mode/Mode";
import ModeItem from "../../Mode/ModeItem/ModeItem";

// application assets
import ManuelItem from '../../../assets/manuellSVG'
import SleepTimeIcon from '../../../assets/sleepTimeSVG'
import ShockVentilationSrc from '../../../assets/rotatingFanSVG'
import HumiditySrc from '../../../assets/dropSVG'
import CO2Src from '../../../assets/leafSVG'
import Divider from '@mui/material/Divider';
//import CustomizedSwitch from "../../CustomizedSwitch/CustomizedSwitch"
import CustomizedSwitch from '../../CustomizedSwitch/CustomizedSwitch';
import log from 'loglevel'
import {t} from 'i18next'
import { Trans } from 'react-i18next'

const styles = {
    switchTimeItemLarge: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 3px !important',
        boxSizing: 'border-box',
    },
    text: {
        marginBottom: 0,
    },
    settings: {
        'height': 24,
        '&:hover': {
            cursor: 'grab',
        },
    },
    switchTimeItemSmall: {
        'display': 'flex',
        'flexDirection':'row',
        'justifyContent': 'space-around',
        'alignItems': 'center',
        'marginBottom': 10,
        '&:nth-child(even)': {
            backgroundColor: theme.palette.custom.selectedMenuItem,
        },
        flex: 1
    },
    swtContainerSmall: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '5px 0 5px 0',
        minWidth: 65,
        height: 50,
    },
};

const modeIcons = {
    1: <ManuelItem/>,
    2: <ShockVentilationSrc/>,
    3: <SleepTimeIcon/>,
    4: <HumiditySrc/>,
    6: <CO2Src/>,
};

/**
 * component for use in switchTime
 * @param classes
 * @param label
 * @param time
 * @param name
 * @param icon
 * @param checked
 * @param handleCheckedChange
 * @param openSettings
 * @returns {*}
 * @constructor
 */
function SwitchTimeItem (props){


   /*  componentDidMount() {
        window.postMessage({type: "stopSyncing"}, "*")
    }

    componentWillUnmount() {
        window.postMessage({type: "startSyncing"}, "*")
    } */
    let [itemExpanded, setExpanded] = useState(false)
    let [activated, setActivated] = useState(props.item.active)

    const handleChange = () => (event, itemExpanded) => {
        event.stopPropagation();
        event.preventDefault();
    };

    const togglePanel = () => {
        setExpanded(!itemExpanded)
    };

    const handleCheckedChange = (checked) => {

        //event.preventDefault();
        //event.stopPropagation();

        //props.handleCheckedChange(event.target.checked)
        props.handleCheckedChange(checked);
    };



    const renderManualSettings = (value) => {
       //console.log('In the manual render, value: ', value)

        return (
            <Slider
                label={t('Scopes.label_fanlevel')}
                value={value || 0}
                disabled={false}
                from={0}
                to={6}
                steps={1}
                handleSliderChange={value => {props.handleDataChange(value)}}
            />
        )
    };

    const renderSleep = (data = 0) => {
        return (
            <Information style={{paddingBottom: 0}} nowrap={false}>
                <Trans i18nKey="Scopes.information_mode_sleep_01"/>
                {data}
                <Trans i18nKey="Scopes.information_mode_sleep_02"/>
                <Trans i18nKey="Scopes.information_mode_sleep_03"/>
            </Information>
        )
    };

    const renderHumidity = (data = 0) => {
        return (
            <div>
                <Information style={{paddingBottom: 0}} nowrap={false}>
                <Trans i18nKey="Scopes.information_mode_humi_01"/>
                </Information>
            </div>
        )
    };

    const renderAirShock = () => {
        return (
            <Slider
                label={t('Scopes.label_fanlevel')}
                value={6}
                disabled={true}
                from={0}
                to={6}
                steps={1}
                handleSliderChange={value => {}}
            />
        )
    };

    const renderC02 = (data) => {
        //TODO
      return (
          <div style={{height: 40}}/>
      )
    };

    const renderModeItem = ({label, id}) => {
        const { item } = props;
        return <ModeItem
                    icon={getModeIcon(id)}
                    label={label}
                    key={`mode_item_${id}`}
                    nowrap={false}
                    checked={item.selectedMode.toString() === id.toString()}
                    handleCheckboxChange={() => props.handleModeChange(id)}
                    style={{width: 'auto', flex: 1}}
                />
    };

    const getModeIcon = (id) => {
        let icon = <CloseIcon/>;
        try {
            icon = modeIcons[id];
        } catch (e) {
            log.error('Icon fetching failed ', e);
        }
        return icon;
    };

    /* Port of strftime(). Compatibility notes:
     *
     * %c - formatted string is slightly different
     * %D - not implemented (use "%m/%d/%y" or "%d/%m/%y")
     * %e - space is not added
     * %E - not implemented
     * %h - not implemented (use "%b")
     * %k - space is not added
     * %n - not implemented (use "\n")
     * %O - not implemented
     * %r - not implemented (use "%I:%M:%S %p")
     * %R - not implemented (use "%H:%M")
     * %t - not implemented (use "\t")
     * %T - not implemented (use "%H:%M:%S")
     * %U - not implemented
     * %W - not implemented
     * %+ - not implemented
     * %% - not implemented (use "%")
     *
     * strftime() reference:
     * http://man7.org/linux/man-pages/man3/strftime.3.html
     *
     * Day of year (%j) code based on Joe Orost's answer:
     * http://stackoverflow.com/questions/8619879/javascript-calculate-the-day-of-the-year-1-366
     *
     * Week number (%V) code based on Taco van den Broek's prototype:
     * http://techblog.procurios.nl/k/news/view/33796/14863/calculate-iso-8601-week-and-year-in-javascript.html
     */
    function strftime(sFormat, date) {
        if (!(date instanceof Date)) date = new Date();
        var nDay = date.getDay(),
            nDate = date.getDate(),
            nMonth = date.getMonth(),
            nYear = date.getFullYear(),
            nHour = date.getHours(),
            aDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            aMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            aDayCount = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
            isLeapYear = function() {
                if ((nYear&3)!==0) return false;
                return nYear%100!==0 || nYear%400===0;
            },
            getThursday = function() {
                var target = new Date(date);
                target.setDate(nDate - ((nDay+6)%7) + 3);
                return target;
            },
            zeroPad = function(nNum, nPad) {
                return ('' + (Math.pow(10, nPad) + nNum)).slice(1);
            };
        return sFormat.replace(/%[a-z]/gi, function(sMatch) {
            return {
                '%a': aDays[nDay].slice(0,3),
                '%A': aDays[nDay],
                '%b': aMonths[nMonth].slice(0,3),
                '%B': aMonths[nMonth],
                '%c': date.toUTCString(),
                '%C': Math.floor(nYear/100),
                '%d': zeroPad(nDate, 2),
                '%e': nDate,
                '%F': date.toISOString().slice(0,10),
                '%G': getThursday().getFullYear(),
                '%g': ('' + getThursday().getFullYear()).slice(2),
                '%H': zeroPad(nHour, 2),
                '%I': zeroPad((nHour+11)%12 + 1, 2),
                '%j': zeroPad(aDayCount[nMonth] + nDate + ((nMonth>1 && isLeapYear()) ? 1 : 0), 3),
                '%k': '' + nHour,
                '%l': (nHour+11)%12 + 1,
                '%m': zeroPad(nMonth + 1, 2),
                '%M': zeroPad(date.getMinutes(), 2),
                '%p': (nHour<12) ? 'AM' : 'PM',
                '%P': (nHour<12) ? 'am' : 'pm',
                '%s': Math.round(date.getTime()/1000),
                '%S': zeroPad(date.getSeconds(), 2),
                '%u': nDay || 7,
                '%V': (function() {
                    var target = getThursday(),
                        n1stThu = target.valueOf();
                    target.setMonth(0, 1);
                    var nJan1 = target.getDay();
                    if (nJan1!==4) target.setMonth(0, 1 + ((4-nJan1)+7)%7);
                    return zeroPad(1 + Math.ceil((n1stThu-target)/604800000), 2);
                })(),
                '%w': '' + nDay,
                '%x': date.toLocaleDateString(),
                '%X': date.toLocaleTimeString(),
                '%y': ('' + nYear).slice(2),
                '%Y': nYear,
                '%z': date.toTimeString().replace(/.+GMT([+-]\d+).+/, '$1'),
                '%Z': date.toTimeString().replace(/.+\((.+?)\)$/, '$1')
            }[sMatch] || sMatch;
        });
    }

    const renderModeSelection = () => {
        const modes = [
            {
                id: 1,
                label: t('Scopes.label_modeitem_manual')
            },
            {
                id: 2,
                label: t('Scopes.label_modeitem_boost')
            },
        /*    {
                id: 3,
                label: 'Schlummer'
            },*/
            {
                id: 4,
                label: t('Scopes.label_modeitem_humi')
            },
            {
                id: 6,
                label: t('Scopes.label_modeitem_co2')
            }
        ];

        return (
            <Mode style={{justifyContent: 'space-between'}}>
                {modes.map(mode => renderModeItem(mode))}
            </Mode>
        )
    };

    function getFullTimeByPart(partTime) {
        let d = new Date();
        d.setHours(partTime.split(":")[0])
        d.setMinutes(partTime.split(":")[1])
        d.setSeconds(0)

        return d;
    }

    function convertToPartTime(time) {
        return strftime("%H:%M:%S", time.$d);
    }

    const renderTimeSelection = () => {
        let { item: {time}, classes } = props;


        return (
            <div style={{display:"flex", flexDirection: 'row', flex: 1, marginLeft: 15, marginBottom: 20, alignItems:"center", }}>
                <Typography style={{...styles.label, marginRight: 20}}>
                <Trans i18nKey="Settings.card_text_devicetime_02"/>
                </Typography>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileTimePicker
                            defaultValue={dayjs('2022-04-17T'+time)}
                            ampm={false}
                            ampmInClock={false}
                            onChange={(time) => props.handleTimeChange(convertToPartTime(time))}
                            className={{
                                "& .MuiPaper-root": {
                                    backgroundColor: "rgba(120, 120, 120, 0.2)"
                                  },
                                  "& .MuiCalendarPicker-root": {
                                    backgroundColor: "rgba(45, 85, 255, 0.4)"
                                  },
                                  "& .MuiPickersDay-dayWithMargin": {
                                    color: "rgb(229,228,226)",
                                    backgroundColor: "rgba(50, 136, 153)"
                                  },
                                  "& .MuiTabs-root": { backgroundColor: "rgba(120, 120, 120, 0.4)" },

                            }}
                         />
                </LocalizationProvider>
            </div>
        )
    };


    const renderTimeProgramSettings = () => {
        const { name, item: {data} } = props;
        //  console.log("renderTimeProgramSettings", props);
        let settings = '';

        switch (name) {
            case t('Scopes.label_modeitem_manual'): settings = renderManualSettings(data); break;
            case t('Scopes.label_modeitem_boost'): settings = renderAirShock(); break;
            //case 'Schlummer': settings = renderSleep(data); break;
            case t('Scopes.label_modeitem_humi'): settings = renderHumidity(data); break;
            case t('Scopes.label_modeitem_co2'): settings = renderC02(data); break;
            default: settings = <div/>;
        }

        return (
            <div style={{flex: 1}}>
                {renderModeSelection()}
                {renderTimeSelection()}
                <Divider sx={{width: "90%", paddingRight:5}}/>
                <div style={{marginLeft: 15, padding: '10px 0'}}>
                    {settings}
                </div>
            </div>
        )
    };

    const getLabel = (label) => {
        switch (label) {
            case 'Schaltzeit 1':
                return t('Misc.label_switchtime') + '1'
            case 'Schaltzeit 2':
                return t('Misc.label_switchtime') + '2'
            case 'Schaltzeit 3':
                return t('Misc.label_switchtime') + '3'
            case 'Schaltzeit 4':
                return t('Misc.label_switchtime') + '4'
            case 'Schaltzeit 5':
                return t('Misc.label_switchtime') + '5'


            default:
                return label
        }
    }

    function toggleActivate(checked){
        setActivated(!checked)
        console.debug("Activate toggle Clicked", activated)
        handleCheckedChange(!checked)
    }

    let { classes, item: { label, time, active, selectedMode}, icon} = props;

    time = getFullTimeByPart(time);

    return (
        <Aux>
            <Hidden only={'xs'}>
                <Accordion
                    square
                    expanded={itemExpanded}
                    onChange={handleChange()}
                    sx={{
                        '&:nth-child(even)': {
                            backgroundColor: theme.palette.custom.selectedMenuItem,
                        },
                        padding:2
                    }}
                >
                    <AccordionSummary sx={{
                          minHeight: 25,
                          padding: '0 10px !important',
                          margin: '0 !important',
                    }}>
                        <div style={styles.switchTimeItemLarge}>
                            <Typography sx={{}} variant={'caption'}>{getLabel(label)}  </Typography>
                            <Typography sx={{}} variant={'caption'}>{moment(time.toString()).format('HH:mm')}</Typography>
                            {getModeIcon(selectedMode)}
                            {/*<Typography className={classes.text} variant={'caption'}>{name}</Typography>*/}
                            {/* {icon} */}
                            <IconButton onClick={() => togglePanel()}>
                                {itemExpanded ? <KeyboardArrowUpIcon style={{color: '#939393', fontSize: 30}}/> : <SettingsSVG/>}
                            </IconButton>
                            <Box onClick={()=>{toggleActivate(activated)}}>
                            <CustomizedSwitch
                                checked={activated}
                                onChange={(e, checked) => handleCheckedChange(e, checked)}
                            />
                            </Box>


                            {/* Custom local Toggle */}
                            {/* Switch is not responding to changes event except in initial loading */}

                        </div>
                    </AccordionSummary>
                    <AccordionDetails sx={{
                        padding: '8px 10px !important', minWidth:"100%"
                    }}>
                        {renderTimeProgramSettings()}
                    </AccordionDetails>
                </Accordion>
            </Hidden>
            <Hidden smUp>
                <Accordion
                    square
                    expanded={itemExpanded}
                    onChange={handleChange()}
                    sx={{
                        '&:nth-child(even)': {
                            backgroundColor: theme.palette.custom.selectedMenuItem,
                        },
                    }}
                >
                    <AccordionSummary sx={{
                          minHeight: 25,
                          padding: '0 10px !important',
                          margin: '0 !important',
                    }}>
                        <div style={styles.switchTimeItemSmall}>
                            <div style={{...styles.swtContainerSmall, flexWrap:"wrap" }}>
                                <Typography variant={'caption'} style={{ marginBottom: 0 }}>{getLabel(label)}  </Typography>
                                <Typography variant={'caption'}>{moment(time.toString()).format('HH:mm')}</Typography>
                            </div>
                            <div style={styles.swtContainerSmall}>
                                {/* <Typography variant={'caption'} style={{ marginBottom: 0 }}>{name}</Typography> */}
                                {getModeIcon(selectedMode)}
                            </div>
                            <Box style={styles.swtContainerSmall} sx={{ flexDirection:'row' }}>
                                <IconButton onClick={() => togglePanel()}>
                                    {itemExpanded ? <KeyboardArrowUpIcon style={{color: '#939393', fontSize: 26}}/> : <SettingsSVG style={{fontSize: 26}}/>}
                                </IconButton>
                                <Box onClick={()=>{toggleActivate(activated)}}>
                                <CustomizedSwitch
                                    checked={activated}
                                    onChange={(e, checked) => handleCheckedChange(e, checked)}
                                />
                                </Box>


                            </Box>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails sx={{
                        padding: '8px 10px !important', minWidth:"100% !important"
                    }}>
                        {renderTimeProgramSettings()}
                    </AccordionDetails>
                </Accordion>
            </Hidden>
        </Aux>
    )
}




SwitchTimeItem.propTypes = {
    name: PropTypes.string.isRequired,
    icon: PropTypes.node.isRequired,
    handleCheckedChange: PropTypes.func.isRequired,
    handleDataChange: PropTypes.func.isRequired,
    handleTimeChange: PropTypes.func.isRequired,
    openSettings: PropTypes.func.isRequired,
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

//export default compose(withStyles(styles), withWidth())(SwitchTimeItem)
export default SwitchTimeItem
